export default __webpack_public_path__ + "static/media/livingroom-1.02379055.png";